import { useParams } from 'react-router';
import { JobDetailsView } from '../components/JobDetailsView';

// Job IDs are always numeric (see JobDetailsView/useJobData). Reject anything
// else here rather than letting it flow through as if it were a real ID —
// WRK-5897: the "Job Not Found" page used to echo the raw, unvalidated URL
// segment back into the page, letting an attacker craft a link like
// /jobs/{arbitrary-phishing-text} that displayed their text under this
// trusted domain (content injection/spoofing).
const NUMERIC_JOB_ID = /^\d+$/;

export default function JobDetailPage() {
  const { jobId } = useParams<{ jobId: string }>();

  if (!jobId || !NUMERIC_JOB_ID.test(jobId)) return null;

  return <JobDetailsView jobId={jobId} />;
}
